import React, { createContext, useState, useContext } from 'react';

// Create a context to hold the Email status
const EmailContext = createContext();

// Custom hook to use the observer context
export const useEmail = () => useContext(EmailContext);

// Provider component that holds the state of userEmail
export const EmailProvider = ({ children }) => {
  const [userEmail, setUserEmail] = useState("z.widdison@wrybillrobotics.com");

  return (
    <EmailContext.Provider value={{ userEmail, setUserEmail }}>
      {children}
    </EmailContext.Provider>
  );
};
